import React from "react";

export const CircularLoader = ({ size = 16, color = "border-white" }) => {
    return (
        <div
            className={`animate-spin rounded-full border-2 ${color} border-t-transparent`}
            style={{ width: size, height: size }}
        />
    );
};
